import Api from "../axios"

export const postLogin= async ({userName, passWord})=>{
    return await Api.post('/login',{
        username: userName,
        password: passWord,
    })
}